"use client";

import dynamic from "next/dynamic";
import { useAtom } from "jotai";
import { dialogAtom } from "@/stores/dialogAtom";

const DownloadAppDialog = dynamic(() => import("./dialogs/DownloadAppDialog"), {
  ssr: false,
});
const SupportDialog = dynamic(() => import("./dialogs/SupportDialog"), {
  ssr: false,
});
const ComingSoonDialog = dynamic(() => import("./dialogs/ComingSoonDialog"), {
  ssr: false,
});

const DIALOG_TUPLES = [
  ["download_app_dialog", DownloadAppDialog],
  ["support_dialog", SupportDialog],
  ["coming_soon_dialog", ComingSoonDialog],
] as const;

export default function GlobalDialog() {
  const [dialog, setDialog] = useAtom(dialogAtom);
  const close = () => setDialog(null);

  const ActiveDialog = DIALOG_TUPLES.find(([id]) => id === dialog?.id)?.[1];

  if (!ActiveDialog) return null;

  return <ActiveDialog open onOpenChange={close} {...dialog?.props} />;
}
